// extracted by mini-css-extract-plugin
export var grid = "search-drawer-module--grid--87846";
export var gridWithRowGap = "search-drawer-module--grid--with-row-gap--8d448";
export var maxWidthContainer = "search-drawer-module--max-width-container--17003";
export var mt0 = "search-drawer-module--mt-0--e20ee";
export var mt1 = "search-drawer-module--mt-1--a7380";
export var mt2 = "search-drawer-module--mt-2--d5621";
export var mt3 = "search-drawer-module--mt-3--c467f";
export var mt4 = "search-drawer-module--mt-4--424fc";
export var mt5 = "search-drawer-module--mt-5--8b1a3";
export var mt6 = "search-drawer-module--mt-6--03998";
export var removeVisuallyHidden = "search-drawer-module--remove-visually-hidden--425c7";
export var searchDrawer = "search-drawer-module--search-drawer--1ed1d";
export var searchDrawerOpen = "search-drawer-module--search-drawer--open--e891e";
export var searchDrawer__alert = "search-drawer-module--search-drawer__alert--f2cf6";
export var searchDrawer__commonTerms = "search-drawer-module--search-drawer__common-terms--a007b";
export var visuallyHidden = "search-drawer-module--visually-hidden--a4a30";
export var widgetBase = "search-drawer-module--widget-base--7eef9";